import { render, staticRenderFns } from "./InstructorsList.vue?vue&type=template&id=dceda87c&scoped=true&"
import script from "./InstructorsList.vue?vue&type=script&lang=js&"
export * from "./InstructorsList.vue?vue&type=script&lang=js&"
import style0 from "./InstructorsList.vue?vue&type=style&index=0&id=dceda87c&lang=scss&scoped=true&"
import style1 from "./InstructorsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceda87c",
  null
  
)

export default component.exports